import React from "react";
import {Field} from "redux-form";
import Shadow from "../Shadow";
import RadioBox from "../forms/RadioBox";
import {maxValue, minValue, maxCircleValue, requiredField} from "../validators/validators";
import {Input} from "../forms/FormControls";
import {connect} from "react-redux";
import { addFile, getFile } from "../../../redux/Calc_reducer";

const Format = props => {

    const {shadow, shadowFalse, resetForm,hasFormat, hasProcessing} = props

    const [disable, setDisable] = React.useState({form1: null, form2: null})
    React.useEffect(() => {
        if (hasProcessing === undefined && ((hasFormat === "Круг" && disable.form1 >= 150) || (disable.form1 >= 150 && disable.form2 >= 150))) {
            shadowFalse(4)
        }
    }, [disable, hasFormat])
    const reload = () => {
        shadowFalse(3)
        setDisable({form1: null, form2: null})
        resetForm([
            "formatMM1",
            "formatMM2",
            "processing",
            "processingValue",
        ])
    }
    const validateCircle = [requiredField, maxCircleValue, minValue]
    const validateSquare = {
        formatMM1: [requiredField, minValue, maxValue],
        formatMM2: [requiredField, minValue, maxValue]
    }
    return <div className={"bl_4_grid_item"}>
        {shadow && <Shadow />}
        <div className="calc_title_box">
            <div className="calc_title">Форма</div>
            <RadioBox name={"format"} value={"Прямоугольник"} func={() => reload()}
                      txt={"Прямоугольник"}/>
            <RadioBox name={"format"} value={"Круг"}  func={reload} txt={"Круг"}/>
            <RadioBox name={"format"} value={"Фигура"}  func={reload} txt={"Фигура"}/>
            <div style={{padding: "10px 0", display: "flex", flexDirection: "column"}}>
                {hasFormat !== undefined && (hasFormat === "Круг" ?
                    <div className="calc_form_for_form">
                        <Field className="calc_input_form" validate={validateCircle}
                               onChange={(e) => {
                                   setDisable({form1: e.target.value, form2: disable.form2})
                               }} component={Input}
                               placeholder={"Диаметр 150-2000"}
                               name={"formatMM1"} id={"MM1"} type={"tel"}
                        />
                        <label htmlFor={"MM1"} className="calc_checker_text1">мм</label>
                    </div> :
                    <React.Fragment>
                        <div className="calc_form_for_form">
                            <Field className="calc_input_form" validate={validateSquare.formatMM1}
                                   onChange={(e) => {
                                setDisable({form1: e.target.value, form2: disable.form2})
                            }} component={Input}
                                   placeholder={"Длина 150-3200"}
                                   name={"formatMM1"} id={"MM1"} type={"number"}/>
                            <label htmlFor={"MM1"} className="calc_checker_text1">мм</label>
                        </div>
                        <div className="calc_form_for_form">
                            <Field className="calc_input_form" validate={validateSquare.formatMM2}
                                   onChange={(e) => {
                                setDisable({form1: disable.form1, form2: e.target.value})
                            }} component={Input}
                                   placeholder={"Ширина 150-3200"}
                                   name={"formatMM2"} id={"MM2"} type={"number"}/>
                            <label htmlFor={"MM2"} className="calc_checker_text1">мм</label>
                        </div>
                    </React.Fragment>)}
            </div>
        </div>
    </div>
}
const mdtp = (dispatch) =>( {
    addFile: (p) => dispatch(addFile(p))
})
export default connect(state => ({
    file: getFile(state)
}), mdtp)(Format)
